export const centralStackedCategories = [
  'trasferimenti',
  'dismissioni',
  'immissioni'
]
export const centralStackedSeriesByCategory = {
  trasferimenti: ['trasferiti'],
  dismissioni: ['dismissioni'],
  immissioni: ['ripristini', 'immissioni']
}
export const centralStackedDetailSeriesByCategory = {
  trasferimenti: ['trasferiti'],
  dismissioni: ['dismPush', 'dismPull'],
  immissioni: [
    'immRipristino',
    'immObbligatori',
    'immDataDifferenziata',
    'immPull',
    'immPush'
  ]
}
export const allSeries = [
  'ripristini',
  'immRipristino',
  'immissioni',
  'immObbligatori',
  'immDataDifferenziata',
  'immPull',
  'immPush',
  'dismissioni',
  'dismPush',
  'dismPull',
  'trasferiti'
]

export const centralStackedSeries = Object.values(
  centralStackedSeriesByCategory
).flat()
export const centralStackedDetailSeries = Object.values(
  centralStackedDetailSeriesByCategory
).flat()

export const APC_SECTION = 'apc_section'
export const AREA_SECTION = 'area_section'
export const CATEGORY_SECTION = 'category_section'
export const CLUSTER_SECTION = 'cluster_section'
export const HYPOTESIS_SECTION = 'hypotesis_section'
export const PERCENTAGE_SECTION = 'percentage_section'
export const UNIT_OF_MEASURE_SECTION = 'unit_of_measure_section'
